import { logQueueActionEvent } from "./logQueueActionEvent";
import type { QueueActionType } from "../properties/event/queueActionProperties";

export function logFavoriteUnfavoriteEvent(operation: string) {
    const type: QueueActionType = operation === "add" ? "FavoriteTrack" : "UnfavoriteTrack";
    logQueueActionEvent(type);
}
